/**
 * NuGuard AI - Loading Spinner Component
 * 
 * Centered loading indicator for async operations.
 */

import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface LoadingSpinnerProps {
  /** Size of the spinner */
  size?: 'sm' | 'md' | 'lg';
  /** Optional message to display */
  message?: string;
  /** Center in full height container */
  fullHeight?: boolean;
  /** Additional CSS classes */
  className?: string;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message,
  fullHeight = false,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3",
        fullHeight && "h-full min-h-[200px]",
        className
      )}
      role="status"
      aria-busy="true"
      aria-label={message || "Loading"}
    >
      <Loader2 className={cn("animate-spin text-primary-500", sizeClasses[size])} />
      {message && (
        <p className="ng-text-muted-sm">{message}</p>
      )}
    </div>
  );
};
